/**
 * 폰 설치 앱의 주소 줄 (2026-09-30) — partials/mobile-shell.html 의 #mAddrBar, 모양은 mobile-shell.css 끝 블록.
 * 설치한 앱에는 브라우저 주소창이 없다: 지금 주소(누르면 복사) · 뒤로 · 앞으로 · 새로고침 · 공유(되는 기기에서만).
 * 보일지는 CSS 가 정한다(html.is-standalone — index.html 머리의 인라인 스크립트 — 이고 폰이고 탭바가 있을 때);
 * 첫 화면의 주소는 서버가 그린다(server/nav_mobile.go mobileAddrText — 같은 규칙, 같은 픽스처
 * tests/unit/fixtures/mobile-addr.json): 전체 이동마다 빈 칸이 모듈 묶음이 다 돌 때까지 남던 것(2026-10-02).
 * 이 모듈은 설치 앱에서 그 뒤의 이동 · 조각 · 뒤로 가기에 주소를 고치고 누름을 받는다.
 * 데스크톱 설치 앱은 탭 틀(/workspace)의 주소 줄을 쓴다.
 */
import { showNotification } from './notifications.js';

let wired = false;

/** 보이는 주소: 경로 + 쿼리 + 조각(호스트는 늘 같다) — 사람이 읽는 글자로 풀되, 깨진 %XX 는 그대로.
 *  돌아가기 링크의 `_from` 은 화면 사이의 배관이라 보이지 않는다(복사는 언제나 전체 주소). */
export function addrText(href) {
    let u;
    try { u = new URL(href); } catch (_) { return String(href || ''); }
    const q = new URLSearchParams(u.search);
    q.delete('_from');
    const qs = q.toString();
    const raw = u.pathname + (qs ? '?' + qs : '') + u.hash;
    try { return decodeURIComponent(raw.replace(/\+/g, ' ')); } catch (_) { return raw; }
}

function bar() { return document.getElementById('mAddrBar'); }

function paint() {
    const b = bar();
    const path = document.getElementById('mAddrPath');
    if (!b || !path) return;
    const text = addrText(window.location.href);
    if (path.textContent !== text) path.textContent = text;
    const back = b.querySelector('[data-m-addr="back"]');
    const fwd = b.querySelector('[data-m-addr="forward"]');
    const nav = window.navigation;
    if (nav && typeof nav.canGoBack === 'boolean') {
        back.disabled = !nav.canGoBack;
        fwd.disabled = !nav.canGoForward;
    } else {
        // Navigation API 가 없는 기기(iOS 등): 앞 칸이 있는지는 알 수 없다 — 뒤로는 기록이 있을 때, 앞으로는 늘 둔다.
        back.disabled = window.history.length <= 1;
        fwd.disabled = false;
    }
}

function copied() {
    const b = bar();
    showNotification((b && b.dataset.copied) || '주소를 복사했습니다', 'success');
}

function copyAddress() {
    const url = window.location.href;
    const fallback = () => {
        const ta = document.createElement('textarea');
        ta.value = url;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
        document.body.appendChild(ta);
        ta.select();
        let ok = false;
        try { ok = document.execCommand('copy'); } catch (_) { ok = false; }
        ta.remove();
        if (ok) copied();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(copied, fallback);
    else fallback();
}

function onClick(e) {
    const btn = e.target.closest && e.target.closest('#mAddrBar [data-m-addr]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    switch (btn.dataset.mAddr) {
    case 'back': window.history.back(); break;
    case 'forward': window.history.forward(); break;
    case 'reload': window.location.reload(); break;
    case 'copy': copyAddress(); break;
    case 'share':
        navigator.share({ title: document.title, url: window.location.href }).catch(() => {});
        break;
    default:
    }
}

export function setupMobileAddr() {
    if (wired || !bar() || !document.documentElement.classList.contains('is-standalone')) return;
    wired = true;
    const share = bar().querySelector('[data-m-addr="share"]');
    if (share) share.hidden = typeof navigator.share !== 'function';
    document.addEventListener('click', onClick);
    // 주소가 바뀌는 길: SPA 이동 · 뒤로/앞으로 · 조각 · 되살린 페이지. 모듈이 제자리에서 고친 주소(replaceState)는
    // Navigation API 의 currententrychange 가 알리고, 그것이 없는 기기는 누른 뒤 한 번 더 본다.
    ['calendar:navigated', 'calendar:page-swapped'].forEach((n) => document.addEventListener(n, paint));
    ['popstate', 'hashchange', 'pageshow'].forEach((n) => window.addEventListener(n, paint));
    if (window.navigation && typeof window.navigation.addEventListener === 'function') {
        window.navigation.addEventListener('currententrychange', paint);
    } else {
        document.addEventListener('click', () => setTimeout(paint, 300), true);
    }
    paint();
}
